import { environment } from "src/environments/environment";
import { ApplicationUserTypeName, UserRole } from "../enums";

export interface UserToken {
  Email: string;
  NameEn: string;
  Phone: string;
  CountryCode: string;
  Role: string;
  RoleCode: UserRole;
  RoleNameAr: string;
  RoleNameEn: string;
  UserId: string;
  UserType: ApplicationUserTypeName;
  DiscountType: string;
  DiscountValue: string;
  Amount: string;
  EntranceType: string;
  aud: string;
  exp: number;
  iss: string;
  jti: string;
  sub: string;
  MembershipId?: string;
  IsActiveMembership?: string;
}

export const convertTokenJWT = (token = localStorage.getItem(environment.tokenPropertyName) as string) => {
  if (token) {
    if (!token.split(".")[1]) return null;

    let base64 = token.split(".")[1].replace(/-/g, "+").replace(/_/g, "/"),
      jsonPayload = decodeURIComponent(
        atob(base64)
          .split("")
          .map((c) => {
            return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
          })
          .join(""),
      );

    return JSON.parse(jsonPayload) as UserToken;
  }

  return null;
};
